import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import {connect} from "react-redux";
import {convertToString, getRelativeTimeFromEpoch, getNodeId} from "../../Utility";
import {FormattedMessage} from "react-intl";
import {getDocumentURL} from "../../handler/ParentDataHandler";
import {getLocale} from "../../handler/LocaleHandler";
import Column from "@amzn/meridian/column";
import RefreshTimer from "../RefreshTimer";
import {bayTableDataClear, getBayTableData, getPlannedCount} from "../../actions/StowBufferAction";
import {refreshInterval, DEFAULT_JACKPOT_BAY_NAME} from "../../constants";
import Tooltip from "@amzn/meridian/tooltip";

class BayTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortColumn: "machine",
            sortDirection: "ascending",
            baseURL: "",
            machineDetails: [],
        }
    }

    nodeId = getNodeId()

    componentDidMount() {
        getDocumentURL().then(value => {
            this.setState({baseURL: value})
        });
        this.fetchBayTableData(this.props.selectedCycle, this.nodeId)
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        this.props.dispatch(bayTableDataClear());
    }

    async fetchBayTableData(selectedCycle, nodeId) {
        this.getDataForBayTable(selectedCycle, nodeId)
        this.timer = setInterval(async () => {
            if (!document.hidden) {
                this.getDataForBayTable(selectedCycle, nodeId)
            }
        }, refreshInterval);
    }

    async getDataForBayTable(selectedCycle, nodeId) {
        await this.props.dispatch(getPlannedCount(nodeId, selectedCycle, this.props.selectedCycleId))
        this.props.dispatch(getBayTableData(nodeId, selectedCycle, 'BAY', this.props.match.params.machine, this.props.stowPackageMetrics))
    }

    getBayName(bayNames) {
        if (bayNames && bayNames.startsWith(DEFAULT_JACKPOT_BAY_NAME)) {
            return bayNames;
        } else if(bayNames !== "") {
            const transformedBayNames = bayNames.split(" ").map((bay) => {
                return bay[0] + bay.slice(2)
            }).join("-")
            return "Bay " + transformedBayNames
        } else {
            return DEFAULT_JACKPOT_BAY_NAME;
        }
    }

    getLastBagScanTime(localMaxScanTime) {
        if(localMaxScanTime)
            return getRelativeTimeFromEpoch(localMaxScanTime)
        else {
            return "-"
        }
    }

    onSort = (sortDetails) => {
        this.setState({
            sortColumn: sortDetails.sortColumn,
            sortDirection: sortDetails.sortDirection
        })
    }

    render() {
        const filteredBayList = this.props.bayList ? this.props.bayList.slice() : [];

        filteredBayList && filteredBayList.sort((a, b) => {
            const fieldA = a[this.state.sortColumn];
            const fieldB = b[this.state.sortColumn];
            if (this.state.sortDirection === "ascending") {
                return convertToString(fieldA)
                    .localeCompare(convertToString(fieldB), getLocale(), {numeric: true});
            } else {
                return convertToString(fieldB)
                    .localeCompare(convertToString(fieldA), getLocale(), {numeric: true});
            }
        })

        return (
            <Column>
                <RefreshTimer deps={[this.props.bayList]}/>
                <Table headerRows={1} showDividers={false} showStripes={false} spacing="small"
                       fixHeaderRows={true}
                       fixHeaderRowsFullWidth={true}
                       sortColumn={this.state.sortColumn}
                       sortDirection={this.state.sortDirection}
                       onSort={this.onSort} data-cy={"bayList"}>
                    <TableRow>
                        <TableCell sortColumn="name">
                            <Tooltip position="top"
                                     title="Bays in the Finger"
                                     id="tooltip.bayName">
                                <FormattedMessage id="bay.bayName" defaultMessage="Bay"/>
                            </Tooltip>
                        </TableCell>
                        <TableCell sortColumn="plannedVolumeSum" alignmentHorizontal="right">
                            <Tooltip position="top"
                                     title="Volume planned for the chute in the Cycle"
                                     id="tooltip.plannedVolume">
                                <FormattedMessage id="bay.plannedVolume" defaultMessage="Planned Volume"/>
                            </Tooltip>
                        </TableCell>
                        <TableCell sortColumn="stowedBufferedPackages" alignmentHorizontal="right">
                            <Tooltip position="top"
                                     title="Volume actually passed to the chute"
                                     id="tooltip.processedVolume">
                                <FormattedMessage id="bay.processedVolume" defaultMessage="Processed Volume"/>
                            </Tooltip>
                        </TableCell>
                        <TableCell sortColumn="localMaxScanTime" alignmentHorizontal="right">
                            <Tooltip position="top"
                                     title="Time when last scan happened in the aisles for which chutes are collecting packages"
                                     id="tooltip.lastBagScan">
                                <FormattedMessage id="bay.lastBagScan" defaultMessage="Last Bag Scan"/>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                    {
                        filteredBayList ? filteredBayList.map(bay => {
                            return <TableRow key={bay.alias} data-cy={"associateDataRow"}>
                                <TableCell>{this.getBayName(bay.name)}</TableCell>
                                <TableCell alignmentHorizontal="right">{bay.plannedVolumeSum}</TableCell>
                                <TableCell alignmentHorizontal="right">{bay.stowedBufferedPackages}</TableCell>
                                <TableCell
                                    alignmentHorizontal="right">{this.getLastBagScanTime(bay.localMaxScanTime)}</TableCell>
                            </TableRow>
                        }) : ""
                    }
                </Table>
            </Column>
        )
    }
}

const mapStateToProps = state => ({
    stowPackageMetrics: state.stowBufferReducer.stowPackageMetrics,
    selectedCycle: state.optionsReducer.options.cycle,
    selectedCycleId: state.optionsReducer.options.cycleId,
    bayList: state.stowBufferReducer.bayList
});
export default withRouter(connect(mapStateToProps)(BayTable));



// WEBPACK FOOTER //
// ./src/components/stowBuffer/BayTable.js